export default __webpack_public_path__ + "static/media/markerRun.c5fafe5a.svg";